import { jsx as _jsx } from "react/jsx-runtime";
const IconCaret2 = () => {
    return (_jsx("svg", { "aria-hidden": "true", focusable: "false", className: "icon icon-caret", viewBox: "0 0 10 6", children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.354 5.354a.5.5 0 01-.708 0L5 1.707 1.354 5.354a.5.5 0 01-.708-.708l4-4a.5.5 0 01.708 0l4 4a.5.5 0 010 .708z", fill: "currentColor" }) }));
};
export default IconCaret2;
